import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { TokenService } from 'src/app/services/common/token.service';
import { FarmersDetailsService } from 'src/app/services/farmers-details.service';
import { JEService } from 'src/app/services/je-services.service';
import { first } from 'rxjs';
import { DepartmentDashboardService } from 'src/app/services/department-dashboard.service';
import { AppLoaderService } from 'src/app/services/app-loader/app-loader.service';
import { IpAddressService } from 'src/app/services/ip-address.service';


@Component({
  selector: 'app-pond-estimate',
  templateUrl: './pond-estimate.component.html',
  styleUrls: ['./pond-estimate.component.scss'],
})
export class PondEstimateComponent implements OnInit {
 num=0;
  pondType = [
    { name: "Bricks Work" },
    { name: "Earth Work" },
  ];
  displayTankDialog: boolean = false;
  displayTankDialog2: boolean = false;
  wrongNotificationCheck: boolean = true;
  wrongNotificationCheck2: boolean = true;
  submitEstimateForm: FormGroup;
  submitEstimateFormStage2: FormGroup;
  submitFalseIntimateForm: FormGroup;
  submitFalseIntimateFormStage2: FormGroup;
  appID: any;
  //flag:any;
  items: any[];
  selectedStatus: any;
  remarks: any;
  isSubmitted: boolean = false;
  isLoading = false;
  userId: any;
  stage:any;
  pondList: any;
  public dialogData: any;
  public dialogData2: any;
  public tankData: any;
  stage2FalseIntimationremarks: any;
  stage2EstimateFormremarks: any;
  stage1FalseIntimationremarks: any;
  stage1EstimateFormRemarks: any;
  ipAddress: any = '000.000.000';


  constructor(
    private _fb: FormBuilder,
    private _personalDetalSer: FarmersDetailsService,
    private messageService: MessageService,
    private pondService: JEService,
    private tokenService: TokenService,
    private deptDashBoardService: DepartmentDashboardService,
    private loader: AppLoaderService ,
    private ipService: IpAddressService,
  ) { }

  ngOnInit(): void {
    this.loadData();
    this.getIP();
    this.submitEstimateForm = this._fb.group({
      topSizeLength: ['', Validators.required],
      topSizeBreadth: ['', Validators.required],
      bottomSizeLength: ['', Validators.required],
      bottomSizeBreadth: ['', Validators.required],
      depth: ['', Validators.required],
      latitude: ['', Validators.required],
      longitude: ['', Validators.required],
      volumeOfEarthWork: ['', Validators.required],
      totalCostOfEarthWork: ['', Validators.required],
      amountOfSubsidy: ['', Validators.required],
      measurementBookCopyPath: ['', Validators.required],
    });

    this.submitEstimateFormStage2 = this._fb.group({
      topSizeLength: ['', Validators.required],
      topSizeBreadth: ['', Validators.required],
      bottomSizeLength: ['', Validators.required],
      bottomSizeBreadth: ['', Validators.required],
      depth: ['', Validators.required],
     typeOfPond: ['', Validators.required],
      toalCostOfWaterTank: ['', Validators.required],
      totalAmountOfSubsidy: ['', Validators.required],
      amountOfTotalSubsidy: ['', Validators.required],
      AssistancePaidAtStage2: ['', Validators.required],
      measurementBookCopyPathStage2: ['', Validators.required],
     // remarks: ['', Validators.required],
    });

    this.submitFalseIntimateForm= this._fb.group({
      uploadThePhotoTaken: ['', Validators.required],
      //remarks: ['', Validators.required],
    });

    this.submitFalseIntimateFormStage2= this._fb.group({
      uploadThePhotoTaken: ['', Validators.required],
      //remarks: ['', Validators.required],
    });
    let actionId = 5; // Do not Change, it is fixed for Farmer Application Verifications
    let sessionToken = sessionStorage.getItem('token');
    let payload = atob(JSON.parse(sessionToken).authToken?.split('.')[1]);
    this.loader.start();
    this.deptDashBoardService.GetStatusMaster(JSON.parse(payload)?.sub, actionId)
      .pipe(first())
      .subscribe({
        next: (data) => {
          this.loader.close();
          this.items = data.$values;
        },
        error: () => {
          this.loader.close();
          this.messageService.add({ severity: 'error', summary: 'Error Message', detail: 'Status Master cant be Loaded' });
        }
      });
  }

  loadData() {
    let sessionToken = sessionStorage.getItem('token');
    let payload = atob(JSON.parse(sessionToken).authToken?.split('.')[1]);
    this.userId = JSON.parse(payload)?.sub;
    this.loader.start();
    this.pondService
      .getFarmerPondVerification(this.userId,this.stage)
      .pipe(first())
      .subscribe({
        next: (data) => {
          this.loader.close();
          console.log('Response Data', data);
          this.tankData = data;
        },
        error: () => {
          this.loader.close();
          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: 'Data error! Dashboard not loaded.',
          });
        },
      });
  }

  getIP() {
    this.ipService.getIPAddress().subscribe((res: any) => {
      this.ipAddress = res.ip;
    });
  }

  get tankFormControls() {
    return this.submitEstimateForm.controls;
  }
  get tankFormControlsStage2() {
    return this.submitEstimateFormStage2.controls;
  }

  get falseIntimationFormControls() {
    return this.submitFalseIntimateForm.controls;
  }

  get falseIntimationFormControlsStage2() {
    return this.submitFalseIntimateFormStage2.controls;
  }

  selectTankRowData(product) {
    console.log(product);
    if(product.Stage==1){
    this.dialogData = [product];
    this.appID = product.appID;
    this.displayTankDialog = true;
    }
   else if(product.Stage==2)
    {
      this.dialogData2 = [product];
      this.appID = product.appID;
      this.displayTankDialog2 = true;
    }
    else{
      console.log("error");
    }
  }

  // selectTankRowData(product) {
  //   this.dialogData = [product];
  //   this.appID = product.appID;
  //   this.displayTankDialog = true;
  // }
  // selectTankRowData2(product) {
  //   this.dialogData2 = [product];
  //   this.appID = product.appID;
  //   this.displayTankDialog2 = true;
  // }


  onCloseDialog() {
    this.submitEstimateForm.reset();
    this.displayTankDialog = false;
    this.isSubmitted = false;
  }

  onUpload(event, formcontrol, uploadElement,step) {
    let file = event.files[0];
    let data = new FormData();
    data.append('file', file);
    if(step==1){
    let phNo = sessionStorage.getItem('farmerPh');
    this._personalDetalSer.uploadFile(data, phNo, formcontrol).subscribe((resp: any) => {
      console.log(resp);
      if (resp.statusCode == 200) {
        this.submitEstimateForm.patchValue({ [formcontrol]: resp.data });
        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: 'File Uploaded with Auto Mode',
        });
      }
    });
    uploadElement.clear();
  }
  else if(step==2){
    let phNo = sessionStorage.getItem('farmerPh');
    this._personalDetalSer.uploadFile(data, phNo, formcontrol).subscribe((resp: any) => {
      console.log(resp);
      if (resp.statusCode == 200) {
        this.submitFalseIntimateForm.patchValue({ [formcontrol]: resp.data });
        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: 'File Uploaded with Auto Mode',
        });
      }
    });
    uploadElement.clear();
  }
  else if(step==3){
    let phNo = sessionStorage.getItem('farmerPh');
    this._personalDetalSer.uploadFile(data, phNo, formcontrol).subscribe((resp: any) => {
      console.log(resp);
      if (resp.statusCode == 200) {
        this.submitEstimateFormStage2.patchValue({ [formcontrol]: resp.data });
        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: 'File Uploaded with Auto Mode',
        });
      }
    });
    uploadElement.clear();
  }
  else {
    let phNo = sessionStorage.getItem('farmerPh');
    this._personalDetalSer.uploadFile(data, phNo, formcontrol).subscribe((resp: any) => {
      console.log(resp);
      if (resp.statusCode == 200) {
        this.submitFalseIntimateFormStage2.patchValue({ [formcontrol]: resp.data });
        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: 'File Uploaded with Auto Mode',
        });
      }
    });
    uploadElement.clear();
  }
  }

  // onUpload(event, formcontrol, uploadElement) {
  //   let file = event.files[0];
  //   let data = new FormData();
  //   data.append('file', file);
  //   let phNo = sessionStorage.getItem('farmerPh');
  //   this._personalDetalSer.uploadFile(data, phNo, formcontrol).subscribe((resp: any) => {
  //     console.log(resp);
  //     if (resp.statusCode == 200) {
  //       this.submitEstimateForm.patchValue({ [formcontrol]: resp.data });
  //       this.messageService.add({
  //         severity: 'success',
  //         summary: 'Success',
  //         detail: 'File Uploaded with Auto Mode',
  //       });
  //     }
  //   });
  //   uploadElement.clear();
  // }

  PostFalseIntimate(reqBody1){
    console.log(reqBody1,"reqBody1");
    this.pondService
    .PondFalseIntimation(reqBody1)
    .pipe()
    .subscribe({
      next: (data) => {
        console.log('POST VENDOR POND FALSE INTIMATION SUCCESS', data);
      },
      error: () => {
        this.messageService.add({
          severity: 'error',
          summary: 'Error Message',
          detail: 'Data Error!  false Intimation Not Added',
        });
      },
      complete: () => {
        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: 'Pond false Intimation Added Successfully',
        });
      },
    });
  }
  
  submitFalseIntimate(){
   this.isSubmitted = true;
   let sessionToken = sessionStorage.getItem('token');
    let payload = atob(JSON.parse(sessionToken).authToken?.split('.')[1]);
  let userId = JSON.parse(payload)?.sub;
  let reqBody1: any = {
    appID: this.appID,
    stage: "0",
    status:this.selectedStatus.flag,
    terminalID: this.ipAddress,
    networkID: this.ipAddress,
    //remarks: this.submitFalseIntimateForm.get('remarks').value,
    photoPath: this.submitFalseIntimateForm.get('uploadThePhotoTaken').value,
    userID: this.userId,
    remarks:this.stage1FalseIntimationremarks,
  };
  this.PostFalseIntimate(reqBody1)
  this.onCloseDialog();
  }

  submitFalseIntimateStage2()
  {
    this.isSubmitted = true;
    console.log("Submit false intimate form stage 2", this.submitFalseIntimateFormStage2.valid);
    let sessionToken = sessionStorage.getItem('token');
    let payload = atob(JSON.parse(sessionToken).authToken?.split('.')[1]);
  let userId = JSON.parse(payload)?.sub;
  let reqBody1: any = {
    appID: this.appID,
    stage: "0",
    status:this.selectedStatus.flag,
    terminalID: this.ipAddress,
    networkID: this.ipAddress,
    //remarks: this.submitFalseIntimateFormStage2.get('remarks').value,
    photoPath: this.submitFalseIntimateFormStage2.get('uploadThePhotoTaken').value,
    userID: this.userId,
    remarks:this.stage2FalseIntimationremarks,
  };
  this.PostFalseIntimate(reqBody1)
  this.onCloseDialog();
  }

  submitEstimate() {
    this.isSubmitted = true;
    console.log("Submit estimate form", this.submitEstimateForm.valid);
    if (this.submitEstimateForm.valid) {
      this.isLoading = true;
      let sessionToken = sessionStorage.getItem('token');
      let payload = atob(JSON.parse(sessionToken).authToken?.split('.')[1]);
    let userId = JSON.parse(payload)?.sub;
      let reqBody: any = {
        appID: this.appID,
        userID:userId,
        status:this.selectedStatus.flag,
        stageType: 0,
        totalAmtStage2:this.num.toString(),
        assistancePaidAtStage2:this.num.toString(),
        topLength: this.submitEstimateForm.get('topSizeLength').value,
        topBreadth: this.submitEstimateForm.get('topSizeBreadth').value,
        topSize: `${this.submitEstimateForm.get('topSizeLength').value *
          this.submitEstimateForm.get('topSizeBreadth').value
          }`,
        bottomLenght: this.submitEstimateForm.get('bottomSizeLength').value,
        bottomBreadth: this.submitEstimateForm.get('bottomSizeBreadth').value,
        bottomSize: `${this.submitEstimateForm.get('bottomSizeLength').value *
          this.submitEstimateForm.get('bottomSizeBreadth').value
          }`,
        depth: this.submitEstimateForm.get('depth').value,
        volumeEarthWork: this.submitEstimateForm.get('volumeOfEarthWork').value,
        tankLat: this.submitEstimateForm.get('latitude').value,
        tankLon: this.submitEstimateForm.get('longitude').value,
        estimateCost: this.submitEstimateForm.get('totalCostOfEarthWork').value,
        estimateCopy: this.submitEstimateForm.get('measurementBookCopyPath')
          .value,
        remarks:this.stage1EstimateFormRemarks,
      };
      this.postVendorPondEstimate(reqBody);
      this.onCloseDialog();
    }
  }


  submitEstimateStage2() {
    this.isSubmitted = true;
    console.log("Submit estimate form stage 2", this.submitEstimateFormStage2.valid);
    if (this.submitEstimateFormStage2.valid) {
      this.isLoading = true;
      let sessionToken = sessionStorage.getItem('token');
      let payload = atob(JSON.parse(sessionToken).authToken?.split('.')[1]);
    let userId = JSON.parse(payload)?.sub;
      let reqBody: any = {
        appID: this.appID,
        stageType: 0,
        userID:userId, 
        totalAmtStage2:this.num.toString(),
        assistancePaidAtStage2:this.num.toString(),
        status:this.selectedStatus.flag,
        topLength: this.submitEstimateFormStage2.get('topSizeLength').value,
        topBreadth: this.submitEstimateFormStage2.get('topSizeBreadth').value,
        topSize: `${this.submitEstimateFormStage2.get('topSizeLength').value *
          this.submitEstimateFormStage2.get('topSizeBreadth').value
          }`,
        bottomLenght: this.submitEstimateFormStage2.get('bottomSizeLength').value,
        bottomBreadth: this.submitEstimateFormStage2.get('bottomSizeBreadth').value,
        bottomSize: `${this.submitEstimateFormStage2.get('bottomSizeLength').value *
          this.submitEstimateFormStage2.get('bottomSizeBreadth').value
          }`,
        depth: this.submitEstimateFormStage2.get('depth').value,
        //typeOfPond: this.submitEstimateFormStage2.get('typeOfPond').value,
        toalCostOfWaterTank: this.submitEstimateFormStage2.get('toalCostOfWaterTank').value,
        totalAmountOfSubsidy: this.submitEstimateFormStage2.get('totalAmountOfSubsidy').value,
        amountOfTotalSubsidy: this.submitEstimateFormStage2.get('amountOfTotalSubsidy').value,
        estimateCopy: this.submitEstimateFormStage2.get('measurementBookCopyPathStage2')
          .value,
         // remarks: this.submitEstimateFormStage2.get('remarks').value,
         remarks:this.stage2EstimateFormremarks,
      };
      this.postVendorPondEstimate(reqBody);
      this.onCloseDialog();
    }
  }

  wrongNotification(submitEstimateForm) {
    this.wrongNotificationCheck = !this.wrongNotificationCheck;
    //this.submitEstimateForm.reset();
   // this.isSubmitted = false;
   
   submitEstimateForm = false;
  }

  wrongNotification2(submitEstimateFormStage2) {
    this.wrongNotificationCheck2 = !this.wrongNotificationCheck2;
    //this.submitEstimateForm.reset();
   // this.isSubmitted = false;
   
   submitEstimateFormStage2 = false;
  }

  postVendorPondEstimate(reqBody) {
    this.pondService
      .vendorPondEstimate(reqBody)
      .pipe()
      .subscribe({
        next: (data) => {
          console.log('POST VENDOR POND ESTIMATE SUCCESS', data);
        },
        error: () => {
          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: 'Data Error! Pond Estimation Not Added',
          });
        },
        complete: () => {
          this.messageService.add({
            severity: 'success',
            summary: 'Success',
            detail: 'Pond Estimation Added Successfully',
          });
        },
      });
    this.loadData();
  }
}
